import { ISelectOptions, IYesOrNo, ITimeOptionType, IStatusFilter } from './models';

export const MOBILE_PREFIX = '+61';

export const YESORNO: IYesOrNo[] = [
  {
    value: 1,
    label: 'Yes'
  },
  {
    value: 2,
    label: 'No'
  }
];

export const STATUS_TYPES = [
  {
    value: '',
    text: 'All',
    className: 'type-gray'
  },
  {
    value: 'APPLICATION',
    text: 'Application Consultation',
    className: 'type-blu'
  },
  {
    value: 'MONITORING',
    text: 'Monitoring Consultation',
    className: 'type-grn'
  },
  {
    value: 'SUPPORT',
    text: 'Support Consultation',
    className: 'type-yel'
  },
  {
    value: 'CONSULTED',
    text: 'Consulted',
    className: 'type-red'
  },
  {
    value: 'TGAAPPLIED',
    text: 'TGA Applied',
    className: 'type-red'
  },
  {
    value: 'TGAAPPROVED',
    text: 'TGA Approved',
    className: 'type-red'
  },
  {
    value: 'TGADECLINED',
    text: 'TGA Declined',
    className: 'type-red'
  },
  {
    value: 'TGADECLINEDCLOSED',
    text: 'TGA Declined-closed',
    className: 'type-gray'
  },
  {
    value: 'SCRIPTSENT',
    text: 'Script Sent',
    className: 'type-gray'
  },
  {
    value: 'FOLLOWEDUP',
    text: 'Followed Up',
    className: 'type-gray'
  }
];

export const IS_DEV = ['development', 'qa', 'staging'];

export const TIMEZONES: ISelectOptions[] = [
  {
    value: 'Australia/Eucla',
    label: '(GMT+8:45) Eucla'
  },
  {
    value: 'Australia/Perth',
    label: '(GMT+8:00) AWST - Perth'
  },
  {
    value: 'Australia/Darwin',
    label: '(GMT+9:30) ACST - Darwin'
  },
  {
    value: 'Australia/Brisbane',
    label: '(GMT+10:00) AEST - Brisbane'
  },
  {
    value: 'Australia/Lindeman',
    label: '(GMT+10:00) AEST - Lindeman'
  },
  {
    value: 'Australia/Adelaide',
    label: '(GMT+10:30) ACDT - Adelaide'
  },
  {
    value: 'Australia/Broken_Hill',
    label: '(GMT+10:30) ACDT - Broken Hill'
  },
  {
    value: 'Australia/Hobart',
    label: '(GMT+11:00) AEDT - Hobart'
  },
  {
    value: 'Australia/Melbourne',
    label: '(GMT+11:00) AEDT - Melbourne'
  },
  {
    value: 'Australia/Sydney',
    label: '(GMT+11:00) AEDT - Sydney'
  }
];

export const GENDER_OPTIONS: ISelectOptions[] = [
  {
    value: 'MALE',
    label: 'Male'
  },
  {
    value: 'FEMALE',
    label: 'Female'
  },
  {
    value: 'NOTTOSAY',
    label: 'Preferred not to say'
  },
  {
    value: 'OTHERS',
    label: 'Other'
  }
];

export const TIME_OPTIONS: ITimeOptionType[] = [
  {
    label: 'N/A',
    value: '',
    disabled: true
  },
  {
    label: '12:00 AM',
    value: '00:00'
  },
  {
    label: '12:30 AM',
    value: '00:30'
  },
  {
    label: '01:00 AM',
    value: '01:00'
  },
  {
    label: '01:30 AM',
    value: '01:30'
  },
  {
    label: '02:00 AM',
    value: '02:00'
  },
  {
    label: '02:30 AM',
    value: '02:30'
  },
  {
    label: '03:00 AM',
    value: '03:00'
  },
  {
    label: '03:30 AM',
    value: '03:30'
  },
  {
    label: '04:00 AM',
    value: '04:00'
  },
  {
    label: '04:30 AM',
    value: '04:30'
  },
  {
    label: '05:00 AM',
    value: '05:00'
  },
  {
    label: '05:30 AM',
    value: '05:30'
  },
  {
    label: '06:00 AM',
    value: '06:00'
  },
  {
    label: '06:30 AM',
    value: '06:30'
  },
  {
    label: '07:00 AM',
    value: '07:00'
  },
  {
    label: '07:30 AM',
    value: '07:30'
  },
  {
    label: '08:00 AM',
    value: '08:00'
  },
  {
    label: '08:30 AM',
    value: '08:30'
  },
  {
    label: '09:00 AM',
    value: '09:00'
  },
  {
    label: '09:30 AM',
    value: '09:30'
  },
  {
    label: '10:00 AM',
    value: '10:00'
  },
  {
    label: '10:30 AM',
    value: '10:30'
  },
  {
    label: '11:00 AM',
    value: '11:00'
  },
  {
    label: '11:30 AM',
    value: '11:30'
  },
  {
    label: '12:00 PM',
    value: '12:00'
  },
  {
    label: '12:30 PM',
    value: '12:30'
  },
  {
    label: '01:00 PM',
    value: '13:00'
  },
  {
    label: '01:30 PM',
    value: '13:30'
  },
  {
    label: '02:00 PM',
    value: '14:00'
  },
  {
    label: '02:30 PM',
    value: '14:30'
  },
  {
    label: '03:00 PM',
    value: '15:00'
  },
  {
    label: '03:30 PM',
    value: '15:30'
  },
  {
    label: '04:00 PM',
    value: '16:00'
  },
  {
    label: '04:30 PM',
    value: '16:30'
  },
  {
    label: '05:00 PM',
    value: '17:00'
  },
  {
    label: '05:30 PM',
    value: '17:30'
  },
  {
    label: '06:00 PM',
    value: '18:00'
  },
  {
    label: '06:30 PM',
    value: '18:30'
  },
  {
    label: '07:00 PM',
    value: '19:00'
  },
  {
    label: '07:30 PM',
    value: '19:30'
  },
  {
    label: '08:00 PM',
    value: '20:00'
  },
  {
    label: '08:30 PM',
    value: '20:30'
  },
  {
    label: '09:00 PM',
    value: '21:00'
  },
  {
    label: '09:30 PM',
    value: '21:30'
  },
  {
    label: '10:00 PM',
    value: '22:00'
  },
  {
    label: '10:30 PM',
    value: '22:30'
  },
  {
    label: '11:00 PM',
    value: '23:00'
  },
  {
    label: '11:30 PM',
    value: '23:30'
  }
];

export const statusTypes: IStatusFilter[] = [
  {
    value: '',
    text: 'All',
    className: 'type-gray'
  },
  {
    value: 'APPLICATION',
    text: 'Application Consultation',
    className: 'type-blu'
  },
  {
    value: 'MONITORING',
    text: 'Monitoring Consultation',
    className: 'type-grn'
  },
  {
    value: 'SUPPORT',
    text: 'Support Consultation',
    className: 'type-yel'
  },
  {
    value: 'CONSULTED',
    text: 'Consulted',
    className: 'type-red'
  },
  {
    value: 'TGAAPPLIED',
    text: 'TGA Applied',
    className: 'type-red'
  },
  {
    value: 'TGAAPPROVED',
    text: 'TGA Approved',
    className: 'type-red'
  },
  {
    value: 'TGADECLINED',
    text: 'TGA Declined',
    className: 'type-red'
  },
  {
    value: 'TGADECLINEDCLOSED',
    text: 'TGA Declined-closed',
    className: 'type-gray'
  },
  {
    value: 'SCRIPTSENT',
    text: 'Script Sent',
    className: 'type-gray'
  },
  {
    value: 'FOLLOWEDUP',
    text: 'Followed Up',
    className: 'type-gray'
  }
];

export const PROFILE_PHOTO_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];

export const WEEKS: ISelectOptions[] = [
  {
    value: 1,
    label: '1 week'
  },
  {
    value: 2,
    label: '2 weeks'
  },
  {
    value: 3,
    label: '3 weeks'
  },
  {
    value: 4,
    label: '4 weeks'
  },
  {
    value: 5,
    label: '5 weeks'
  },
  {
    value: 6,
    label: '6 weeks'
  }
];

export const DAYS_OF_WEEKS: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const DAYS_OF_WEEKS_OPTION: ISelectOptions[] = [
  {
    label: 'S',
    value: 'SUN'
  },
  {
    label: 'M',
    value: 'MON'
  },
  {
    label: 'T',
    value: 'TUE'
  },
  {
    label: 'W',
    value: 'WED'
  },
  {
    label: 'Th',
    value: 'THU'
  },
  {
    label: 'F',
    value: 'FRI'
  },
  {
    label: 'S',
    value: 'SAT'
  }
];

export const TABLE_PER_PAGE: ISelectOptions[] = [
  {
    label: '5 per page',
    value: 5
  },
  {
    label: '10 per page',
    value: 10
  },
  {
    label: '20 per page',
    value: 20
  },
  {
    label: '25 per page',
    value: 25
  },
  {
    label: '50 per page',
    value: 50
  },
  {
    label: '100 per page',
    value: 100
  }
];

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24
};

export const STATE_OPTIONS: ISelectOptions[] = [
  { label: 'ACT', value: 'ACT' },
  { label: 'NSW', value: 'NSW' },
  { label: 'NT', value: 'NT' },
  { label: 'QLD', value: 'QLD' },
  { label: 'SA', value: 'SA' },
  { label: 'TAS', value: 'TAS' },
  { label: 'VIC', value: 'VIC' },
  { label: 'WA', value: 'WA' }
];

export const STEPS_ONBOARD = {
  1: 'Next',
  2: 'Complete'
};

export const EVENTS_COLOR = {
  INITIAL: {
    color: '#8D3E30',
    title: 'Initial Consultation'
  },
  STANDARD: {
    color: '#CE744B',
    title: 'Standard Consultation'
  },
  SHORT: {
    color: '#0F5342',
    title: 'Short Consultation'
  },
  STANDARD_FOLLOWUP: {
    color: '#CE744B',
    title: 'Standard Follow-up Consultation'
  },
  EXTENDED_FOLLOWUP: {
    color: '#0F5342',
    title: 'Extended Follow-up Consultation'
  }
};

export const DEFAULT_ALL_DAY_MINUTES = 60;

export const CONT_CONSULTATION: string[] = ['ONCALL', 'CALLEND', 'POSTCALL'];

export const LIFESTYLE_ADVICE: ISelectOptions[] = [
  { label: 'Meditation', value: 'MEDITATE' },
  { label: 'Walking', value: 'WALK' },
  { label: 'Movements (any)', value: 'MOVE' },
  { label: 'Reduct high intensity Training', value: 'TRAINING' },
  { label: 'Avoid Caffeine', value: 'CAFFEINE' },
  { label: 'Avoid Alcohol', value: 'ALCOHOL' },
  { label: 'Eat fish and omega-3 fats', value: 'FISH' },
  { label: 'Reduce red meat intake', value: 'REDMEAT' },
  {
    label: 'Reduce trans fats intake (often found in fried foods, package sweets)',
    value: 'TRANSFAT'
  },
  { label: 'Eat vegetables and fruits', value: 'VEGETABLESANDFRUITS' },
  { label: 'Increase protein intake', value: 'PROTEIN' },
  { label: 'Add leafy green vegetables', value: 'LEAFY' },
  { label: 'Avoid Glutein', value: 'GLUTEIN' },
  { label: 'Add fiber to diet', value: 'FIBER' },
  { label: 'Recommendation (Other +)', value: 'OTHER' }
];

export const LIFESTYLE_ADVICE_DURATION: ISelectOptions[] = [
  { label: '10 mins', value: '10' },
  { label: '15 mins', value: '15' },
  { label: '30 mins', value: '30' }
];

export const LIFESTYLE_ADVICE_FREQUENCY: ISelectOptions[] = [
  { label: 'daily', value: 'DAILY' },
  { label: '3-4 times per week', value: '34TIMESWEEK' },
  { label: 'Max 1-2 times per week', value: '12WEEK' },
  { label: 'after 12pm', value: 'AFTER12' },
  { label: 'as much as possible', value: 'AMAP' },
  { label: '3-4 servings per week', value: '34SERVINGSWEEK' },
  { label: '2-3 servings per day', value: '23SERVINGSWEEK' },
  { label: 'with every meal, especially at breakfast', value: 'EVERYMEAL' },
  { label: 'to every lunch and dinner', value: 'LUNCHDINNER' },
  { label: 'aim for 25g daily', value: '25GDAILY' }
];

export const REFERRAL_TYPE: ISelectOptions[] = [
  { label: 'Gynaecologist', value: 'GYNAECOLOGIST' },
  { label: 'Pap Smear', value: 'PAP SMEAR' },
  { label: 'Imaging', value: 'IMAGING' },
  { label: 'Pathology', value: 'PATHOLOGY' },
  { label: 'Pelvic Physio', value: 'PELVIC PHYSIO' },
  { label: 'Dietitian', value: 'DIETITIAN' },
  { label: 'Psychology', value: 'PSYCHOLOGY' },
  { label: 'Sex Counselling', value: 'SEX COUNSELLING' },
  { label: 'Naturopath', value: 'NATUROPATH' },
  { label: 'Acupuncture', value: 'Acupuncture' },
  { label: 'Other', value: 'OTHER' }
];

export const REFERRAL_TIMEFRAME: ISelectOptions[] = [
  { label: 'ASAP', value: 'ASAP' },
  { label: 'Within Fortnight', value: 'WITHIN FORTNIGHT' },
  { label: 'Within 1 month', value: 'WITHIN 1 MONTH' },
  { label: 'Within 3-6 Months', value: 'WITHIN 3-6 MONTHS' },
  { label: 'Other', value: 'OTHER' }
];

export const CLINICAL_NOTES: ISelectOptions[] = [
  { label: 'History (Patient and Family)', value: 'HISTORY' },
  { label: 'Current Conditions/Symptoms', value: 'CURRENTCONDITION' },
  { label: 'Medications', value: 'MEDICATIONS' },
  { label: 'Previous Therapies', value: 'PREVIOUSTHERAPY' },
  { label: 'Goals', value: 'GOALS' },
  { label: 'Menstruation', value: 'MENSTRUATION' },
  { label: 'Fertility', value: 'FERTILITY' },
  { label: 'Sleep', value: 'SLEEP' },
  { label: 'Energy', value: 'ENERGY' },
  { label: 'Nutrition', value: 'NUTRITION' },
  { label: 'Gut Health', value: 'GUTHEALTH' },
  { label: 'Mental Health', value: 'MENTALHEALTH' },
  { label: 'Social', value: 'SOCIAL' },
  { label: 'Next Review Date', value: 'NEXTREVIEWDATE' },
  { label: 'Pinned Alerts', value: 'PINNEDALERTS' },
  { label: 'Sex', value: 'SEX' },
  { label: 'Impression', value: 'IMPRESSION' },
  { label: 'Plan', value: 'PLAN' },
  { label: 'Presenting Conditions / Symptoms', value: 'PRESENTINGCONDITION' },
  { label: 'Systems Review', value: 'SYSTEMSREVIEW' },
  { label: 'Patient Progress', value: 'PATIENTPROGRESS' },
  { label: 'Assessment', value: 'ASSESSMENT' },
  { label: 'Clinical Notes', value: 'OTHER' } // Others before
];


export const CURRENTLY_SEXUALLY_ACTIVE_OPTIONS = [
  'Yes, with one regular partner',
  'Yes, with multiple partners',
  'No, but I have been in the past',
  'No, I have never been sexually active',
  'Prefer not to say'
];

export const PERIOD_IRREGULARITY_OPTIONS = [
  'Cycles are shorter than every 21 days',
  'Cycles are longer than every 35 days',
  'My cycle length and timing is very unpredictable ',
  'I’m not sure / don’t track my cycle',
  'No'
];


export const DISPENSING_INTERVAL_OPTIONS: ISelectOptions[] = [
  ...Array.from({ length: 14 }, (_, i) => ({
    label: `${i + 1} Day${i + 1 > 1 ? 's' : ''}`,
    value: i + 1
  })),
  { label: '21 Days', value: 21 }
];


export const INBOX_STATUS_FILTER: ISelectOptions[] = [
  { label: 'All Status', value: 'all' },
  { label: 'Pending Review', value: 'PENDING_REVIEW' },
  { label: 'Reviewed', value: 'REVIEWED' },
  { label: 'Completed', value: 'COMPLETED' }
];

export const INBOX_TYPE_FILTER: ISelectOptions[] = [
  { label: 'All Types', value: 'all' },
  { label: 'Referral', value: 'Referral' },
  { label: 'ID Document', value: 'ID Document' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Results', value: 'Results' },
  { label: 'Other', value: 'Other' }
];

export const INBOX_PRIORITY_FILTER: ISelectOptions[] = [
  { label: 'All Priority', value: 'all' },
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Non-urgent', value: 'NON_URGENT' }
];

export const INBOX_ASSIGNED_STAFF_FILTER: ISelectOptions[] = [
  { label: 'Dr. Smith', value: 'dr_smith' },
  { label: 'Nurse Amy', value: 'nurse_amy' },
  { label: 'Dr. Johnson', value: 'dr_johnson' }
];

export const INBOX_PRIORITY_OPTION: ISelectOptions[] = [
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' }
];

export const INBOX_PRIORITY_OPTIONS: ISelectOptions[] = [
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Non-urgent', value: 'NON_URGENT' }
];

export const REVIEW_RESULT_OPTIONS: ISelectOptions[] = [
  { label: 'Normal', value: 'NORMAL' },
  { label: 'Abnormal', value: 'ABNORMAL' }
];

export const INBOX_TYPE_OPTIONS: ISelectOptions[] = [
  { label: 'Referral', value: 'Referral' },
  { label: 'ID Document', value: 'ID Document' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Results', value: 'Results' },
  { label: 'Others', value: 'Others' }
];